import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import AppLayout from "./layout/AppLayout";
import { Toaster } from "./components/ui/toaster";

import TestBackendPage from './components/TestBackendPage';

// Pages (versions harmonisées)
import TableauDeBordPage from "./pages/TableauDeBordPage";
import CartePage from "./pages/CartePage";
import AnimauxPage from "./pages/AnimauxPage";
import ZonesPage from "./pages/ZonesPage";
import ProprietairesPage from "./pages/ProprietairesPage";
import ListeChevauxPage from "./pages/ListeChevauxPage";
import ParametresPage from "./pages/ParametresPage";
import UnifiedHorsePage from './pages/UnifiedHorsePage';
import TableauDeBordListe from './pages/TableauDeBordListe';
import ActesPage from "./pages/ActesPage";


export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Routes SANS layout (pas de menu) */}
          <Route path="/tableau-bord-liste" element={<TableauDeBordListe />} />
          <Route path="/liste-chevaux-tv" element={<ListeChevauxPage />} />
          
          {/* Routes AVEC layout (avec menu) */}
          <Route element={<AppLayout />}>
            {/* Page par défaut */}
            <Route path="/" element={<Navigate to="/tableau-bord" replace />} />

            {/* Routes principales */}
            <Route path="/tableau-bord" element={<TableauDeBordPage />} />
            <Route path="/carte" element={<CartePage />} />
            <Route path="/animaux" element={<AnimauxPage />} />

            {/* UNE SEULE route pour tous les chevaux */}
            <Route path="/animaux/:id" element={<UnifiedHorsePage />} />
            
            <Route path="/zones" element={<ZonesPage />} />
            <Route path="/proprietaires" element={<ProprietairesPage />} />
            <Route path="/liste-chevaux" element={<ListeChevauxPage />} />
            <Route path="/actes" element={<ActesPage />} />
            <Route path="/parametres" element={<ParametresPage />} />
            <Route path="/test-backend" element={<TestBackendPage />} />

          </Route>
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}